import { S25Bootstrap } from "../util/core/s25.bootstrap";
import { S25WsNode } from "./S25WsNode";

export namespace Image {
    export type TypeId = Types.image | Types.diagram;

    export const enum Types {
        image = 1,
        diagram = 2,
    }

    /** Breakpoint-based sizing options for responsive image display. */
    export interface BootstrapOptions {
        /** Bootstrap breakpoint identifier, e.g. 'sm', 'md', 'lg'. */
        point?: keyof typeof S25Bootstrap.breakpoints;
        /** Number of grid columns the image occupies at the given breakpoint. */
        numCols?: number;
        /** Optional max pixel-width override. */
        maxWidth?: number;
    }

    /**
     * Metadata-only shape returned by /images.json (list or single lookup).
     * Does NOT include binary image data or file info.
     */
    export interface ImagesI extends S25WsNode {
        image_desc?: string;
        image_id?: number;
        image_name?: string;
        image_type?: TypeId;
        image_type_name?: string;
    }

    /**
     * Full shape returned by /image.json (single image with binary data).
     * Extends the metadata shape with file info and the raw base64 payload.
     */
    export interface ImageFullI extends ImagesI {
        file_name?: string;
        image_data?: string;
    }

    /**
     * Returns the best available alt text for an image.
     * Priority: image_desc (description) → image_name (title/name) → empty string.
     */
    export function altText(image: ImagesI | null | undefined): string {
        return image?.image_desc?.trim() || image?.image_name?.trim() || "";
    }
}
